import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export const userProductPermissionsSliceSelector = (state: RootState) => state.userProductPermissions;

export const userProductPermissionsSelector = createSelector(
  userProductPermissionsSliceSelector,
  (state) => state.permissions,
);

export const loadedCompanyIdUserProductPermissionsSelector = createSelector(
  userProductPermissionsSliceSelector,
  (state) => state.loadedCompanyId,
);

export const hasDataAuditAccessSelector = createSelector(userProductPermissionsSelector, (permissions) =>
  permissions.some(({ productRoleName }) => productRoleName.startsWith('DataAudit')),
);
